module.exports = __webpack_public_path__ + "pr.svg?db39d157f68dacf306f80c9ae33b2115";